import pokemon from "pokemon"
import { customAlphabet } from "nanoid"

const numbers = "0123456789"

export function displayNameGenerator(): string {
  const nanoid = customAlphabet(numbers, 6)
  return `${pokemon.random()}_${nanoid()}`
}

export function isValidEmail(email: string): boolean {
  const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  return re.test(String(email).toLowerCase())
}

export function isEmptyString(text?: string | null): boolean {
  return Boolean(text === null || text === undefined || text === "" || text === "<p><br></p>")
}
